var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"trigger",staticStyle:{"clear":"both","background-color":"transparent","height":"1px"},attrs:{"data-ref":"trigger"}},[_vm._v("   ")])}
var staticRenderFns = []

export { render, staticRenderFns }